<template>
    <v-row>
        <v-col cols="12" sm="6" md="4" offset-md="8">
            <search-input @search="performSearch" v-model="search" />
        </v-col>

        <v-col cols="12">
            <v-data-table
                :headers="headers"
                :items="filteredItems"
                :loading="loading"
                class="mt-3"
            >
                <template slot="no-data">
                    <div class="text-xs-center">Sin datos</div>
                </template>

                <template v-slot:item.active="{ item }">
                    <v-chip :color="item.active ? 'success' : 'grey'" dark small>
                        {{ item.active ? 'Activo' : 'Inactivo' }}
                    </v-chip>
                </template>

                <template v-slot:item.rolesCount="{ item }">
                    {{ item.roleTemplates ? item.roleTemplates.length : 0 }}
                </template>

                <template v-slot:item.action="{ item }">
                    <edit-button @click="$emit('update', item)" />
                    <delete-button :disabled="item.nombre === 'Estándar'" @click="$emit('delete', item)" />
                </template>
            </v-data-table>
        </v-col>
    </v-row>
</template>

<script>
import PlanProvider from '../../../providers/PlanProvider'
import { EditButton, DeleteButton, SearchInput } from '@dracul/common-frontend'

export default {
    name: 'PlanList',
    components: { EditButton, DeleteButton, SearchInput },
    data() {
        return {
            items: [],
            loading: false,
            search: ''
        }
    },
    computed: {
        headers() {
            return [
                { text: 'Nombre', value: 'nombre' },
                { text: 'Descripción', value: 'descripcion' },
                { text: 'Roles', value: 'rolesCount', sortable: false },
                { text: 'Estado', value: 'active', sortable: false },
                { text: 'Acciones', value: 'action', sortable: false }
            ]
        },
        filteredItems() {
            if (!this.search) return this.items
            const s = this.search.toLowerCase()
            return this.items.filter(p =>
                (p.nombre || '').toLowerCase().includes(s) ||
                (p.descripcion || '').toLowerCase().includes(s)
            )
        }
    },
    created() {
        this.fetch()
    },
    methods: {
        performSearch() {
            // search is reactive via computed
        },
        fetch() {
            this.loading = true
            PlanProvider.fetchPlanes()
                .then(r => {
                    this.items = r.data.adminPlanFetch || []
                })
                .catch(err => console.error(err))
                .finally(() => this.loading = false)
        }
    }
}
</script>
